import {Injectable} from '@angular/core';
import {RequesterService} from "../../../shared/services/requester/requester.service";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {BehaviorSubject} from "rxjs";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../store";
import * as fromStore from '../../../store';
import {TypeUtils} from "../../../shared/utils/type-utils";
import {Config} from "../../../config/config";
import mockData from "../../../../assets/json/mock-data.json";
import {map} from "rxjs/operators";
@Injectable()
export class BuilderTemplatesService {

  private currentWorkspaceId: any;
  private ownerWorkspaceId: any;

  constructor(
    private _requester: RequesterService,
    private _store: Store<DbStoreState>,
  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe( workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
  }

  public getBuilderTemplates(): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.core
      .get(`sites`, null, false)
      .pipe(map((response: DbResponse): DbResponse => {
        if (response && response.success) {
        }
        return response;
      })));
  }

  public getBuilderTemplatesCategories(): BehaviorSubject<DbResponse> {
    return <BehaviorSubject<DbResponse>>(this._requester.core
      .get(`workspaces/${this.currentWorkspaceId}/template-categories`, null, false)
      .pipe(map((response: DbResponse): DbResponse => {
        if (response && response.success) {
        }
        return response;
      })));
  }

  public importBuilderTemplates(websiteId: number, templateId: number, templateType: string, templateTitle: string, postStatus: string, kitData?, menuItemPosition?, menuItemId?, menuTermId?): BehaviorSubject<DbResponse> {
    let postData: object = {
      domain_id: websiteId,
      type: 'site',
      action: 'install',
      post_status: postStatus,
      product_title: templateTitle,
      page_title: templateTitle
    };
    if (menuItemPosition) {
      postData = Object.assign({}, postData, {
        menu_item_position: menuItemPosition,
        menu_term_id: menuTermId,
        menu_item_id: menuItemId,
        post_status: 'publish'
      });
    }
    if (!TypeUtils.isNull(kitData)) {
      postData = Object.assign({}, postData, {
        kit_data: kitData
      });
    }

    return this._requester.manager
      .post(`workspaces/${this.currentWorkspaceId}/manager/templates/${templateId}/actions`, null, postData);
  }


  public getLastBuilderTemplate(websiteId: number): BehaviorSubject<DbResponse> {
    if (+websiteId === Config.demoDomainId) {
      const response: any = mockData['last'];
      return new BehaviorSubject<DbResponse>(response);
    }
    return this._requester.aiAssistant
      .get(`templates/workspaces/${this.currentWorkspaceId}/domains/${websiteId}/last`);
  }

}
